import React from 'react';
import { Form, Grid, Button, Dropdown, Checkbox, Radio } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import $ from 'jquery';

import server from '../../functions/server';

export default class Add extends React.Component {

  state = { open: false, gstin: '', duedate: this.getFormatedDate(new Date()), positionsOption: [], filter: 0, toDay: this.getFormatedDate(new Date()), haveRef: 0, ref_customer: 0, ref_no: "" };

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x = dates.getFullYear() + "-" + month + "-" + date;
    return x;
  }

  handleChange = (key) => (e, { value }) => {
    this.setState({
      [key]: value,
      isCustomer: this.props.isCustomer
    })
  }

  componentDidMount() {
    if (this.props.customer) {
      this.setState({
        name: this.props.customer.name,
        mobile: this.props.customer.mobile,
        address: this.props.customer.address,
        gstin: this.props.customer.gstin,
        duedate: this.props.customer.duedate,
        filter:  this.convertIntoNumber(this.props.customer.is_customer),
        haveRef: this.convertIntoNumber(this.props.customer.customer_reference_id) > 0 ? 1 : 0,
        ref_customer: this.convertIntoNumber(this.props.customer.customer_reference_id), 
        ref_no: this.convertIntoNumber(this.props.customer.customer_reference_no)
      });
    }
  }

  componentDidUpdate(props) {
    if (props.isCustomer != this.props.isCustomer) {
      this.setState({ filter: this.props.isCustomer })
    }
  }


  save = () => {
    let context = this;
    let customerName = this.state.name; let customerMobile = this.state.mobile;
    let customerAddress = this.state.address; let customerGSTIN = this.state.gstin;
    let refCustomer = this.state.ref_customer; let refNo = this.state.ref_no;
    let dueDate = this.state.duedate;
    let isCustomer = 'All'
    if (isCustomer == this.state.filter) {
      alert('Please Select '+this.props.buttonName);
      return;
    }
    else {
      isCustomer = this.state.filter;
    }
    if (!customerName || customerName.length < 1) {
      alert("Invalid "+this.props.buttonName+" Name");
      return false;
    }
    if (!customerMobile || isNaN(customerMobile) || customerMobile.length !== 10) {
      alert(this.props.buttonName+" Mobile Number should be 10 Characters and It Should only have numbers");
      return false;
    }
    if (!customerAddress || customerAddress.length < 1) {
      alert("Enter "+this.props.buttonName+" Address");
      return false;
    }
    let url = server() + "/customers/addcustomer.php";
    let data = {
      name: customerName, mobile: customerMobile,
      address: customerAddress, gstin: customerGSTIN,
      dueDate: dueDate, isCustomer, refCustomer, refNo
    }
    if (this.props.customer) {
      url = server() + "/customers/editcustomer.php";
      data["id"] = this.props.customer.id;
    } else {
      data["id"] = this.props.data.id;
    }
    $.ajax({
      url: url,
      data, type: 'POST',
      beforeSend: function(x) {
          context.setState({
            load: true,
            buttonLoading: true
          });
      }
    }).done((data) => {
      let open = true;
      if (data == "1") {
        open = false;
        context.props.refresh();
        this.setState({
          name: '', mobile: '', address: '', gstin: '', duedate: this.getFormatedDate(new Date()), 
          filter: context.props.isCustomer, buttonLoading: false, haveRef: 0, ref_customer: 0, ref_no: ""
        });
      }
      context.setState({
        load: false, open
      })
    });
  }

  handleChange1 = (name) => event => {
    this.setState({ [name]: event.target.value })
  }

  addCustomer() {
    let limitedOrder = this.props.data.primeLimitation;
    let context = this;
    let url = server() + '/customers/checklimit.php';
    let data = {shop_id: this.props.data.id, today: this.state.toDay};
    $.ajax({
      url: url,
      data, type: 'POST',
      beforeSend: function(x) {
          context.setState({
            buttonLoading: true
          });
      }
    }).done((data) => {
      try {
        data = data.trim();
        data = context.convertIntoNumber(data);
        if (data < 0) {
          alert('Error to Add Customer \nPlease Contact +91 6383306541');
        }
        if (data <= limitedOrder) {
          context.setState({open: true, buttonLoading: false})
        }
        else {
          alert('Please upgrade your Prime pack!!!');
          context.setState({ buttonLoading: false })
          return;
        }
      } catch (error) {
        context.setState({ buttonLoading: false })
        alert('Error to Add Customer');
      }
    });
  }

  convertIntoNumber = (value) => {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  handleChangess(filter) { this.setState({ filter }) }

  makeCustomerOption = () => {
    let options = [];
    if (this.props.customers && this.props.customers.length > 0) {
      for (let index = 0; index < this.props.customers.length; index++) {
        const customer = this.props.customers[index];
        if (this.props?.shopDetails?.id == 532) {
          let positions = customer.positions ? JSON.parse(customer.positions) : [];
          if (positions.length == 2) {
          }
          else {
            options.push({ key: index, text: customer.id + ' - ' + customer.name + ' - ' + customer.mobile, value: this.convertIntoNumber(customer.id) });
          }
        }
        else {
          options.push({ key: index, text: customer.id + ' - ' + customer.name + ' - ' + customer.mobile, value: this.convertIntoNumber(customer.id) });
        }
      }
    }
    return options;
  }

  changeRefNo = (f, { value }) => {
    this.setState({ ref_no: value })  
  }

  changeRefCustomer = (f, { value }) => {
    let positionsOption = [];
    for (let index = 0; index < this.props.customers.length; index++) {
        const customer = this.props.customers[index];
        if (customer.id == value) {
          let option = customer.positions ? JSON.parse(customer.positions) : [];
          option.map((temp) => {
            if (!temp.position) {
              positionsOption.push({ key: "Left", text: "Left", value: 0 });
              positionsOption.push({ key: "Right", text: "Right", value: 1 });
            }
            if (temp.position == 'Left') {
              positionsOption.push({ key: "Right", text: "Right", value: 1 }); 
            }
            if (temp.position == 'Right') {
              positionsOption.push({ key: "Left", text: "Left", value: 0 });  
            }
          })
          break;
        }
    }
    this.setState({ ref_customer: value, positionsOption })  
  }

  render() {
    let customer = this.props.customer;
    let title = "Add "+this.props.buttonName;
    let button = (
      <Button loading={this.state.buttonLoading} color="green" onClick={this.addCustomer.bind(this)}>
        {this.props.buttonName}
      </Button>
    );
    if (customer) {
      title = "Edit "+this.props.buttonName;
      button = (
        <Button color="green" onClick={() => this.setState({open: true, filter: this.props.isCustomer})}>
          Edit
        </Button>
      );
    }
    let customerOption = this.makeCustomerOption()
    return (
      <span>
        { button }
        <Dialog
          fullWidth={true}
          maxWidth={'md'}
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">{title}</DialogTitle>
          <DialogContent style={{margin: 15}}>
            <Grid columns={2}>
              <Grid.Row>
                <Grid.Column>
                  <Form.Input fluid label={'Name'} placeholder={'Name'}
                    value={this.state.name} onChange={this.handleChange("name")}/>
                </Grid.Column>
                <Grid.Column>
                  <Form.Input fluid label={'Mobile'} placeholder={'Mobile'}
                    value={this.state.mobile} onChange={this.handleChange("mobile")}/>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form.Input fluid label={'Address'} placeholder={'Address'}
                    value={this.state.address} onChange={this.handleChange("address")}/>
                </Grid.Column>
                <Grid.Column>
                  <Form.Input fluid label={'GSTIN'} placeholder={'GSTIN'}
                    value={this.state.gstin} onChange={this.handleChange("gstin")}/>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Checkbox
                    label='Reference'
                    onChange={(e, data) => this.setState({ haveRef: data.checked ? 1 : 0 })}
                    checked={this.state.haveRef}
                  /><br/>
                  {
                    this.state.haveRef ? 
                    <Dropdown value={this.state.ref_customer} onChange={this.changeRefCustomer} fluid placeholder='State'  options={customerOption} search selection /> : null
                  }
                </Grid.Column>
                <Grid.Column>
                <br/>
                {
                  this.state.haveRef ? 
                  <div style={{ marginTop: 5 }}>
                    {
                      this.props.shopDetails.id == 532 ? 
                      <Dropdown value={this.state.ref_no} onChange={this.changeRefNo} fluid placeholder='Position'  options={this.state.positionsOption} search selection /> :
                      <Form.Input value={this.state.ref_no} onChange={this.handleChange("ref_no")} fluid label={'Reference No'} placeholder={'Reference No'} />
                    }
                  </div>
                  : null 
                }
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  Due Date<br/>
                  <input type='date' value={this.state.duedate} onChange={this.handleChange1("duedate")} />
                </Grid.Column>
                <Grid.Column>
                  {
                    this.props.buttonName == 'Add Customer/Vendor' ? 
                    <div>
                      <Radio label='Customer' name='radioGroup' value={0}
                        checked={this.state.filter === 0} onChange={this.handleChangess.bind(this, 0)} />
                      <Radio label={'Vendor'} name='radioGroup' value={1} style={{marginLeft: 5}}
                        checked={this.state.filter === 1} onChange={this.handleChangess.bind(this, 1)} />
                    </div>:
                    <div>
                      {
                        this.props.buttonName == 'Add Customer/Purchaser' ? 
                        <div>
                          <Radio label='Customer' name='radioGroup' value={0}
                            checked={this.state.filter === 0} onChange={this.handleChangess.bind(this, 0)} />
                          <Radio label={'Purchaser'} name='radioGroup' value={1} style={{marginLeft: 5}}
                            checked={this.state.filter === 1} onChange={this.handleChangess.bind(this, 1)} />
                        </div> : null
                      }
                    </div>
                  }
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button negative onClick={() => this.setState({open: false})}>Cancel</Button>
            <Button loading={this.state.buttonLoading} positive icon='checkmark' labelPosition='right' content='Yes' onClick={this.save}/>
          </DialogActions>
        </Dialog>
      </span>
    );
  }

}
